import { Container, Row, Col } from 'react-bootstrap';
import Comments from '../cart/Comments';
import MUIModal from '../shared/MUIModal';

const CommentDetailsModal = (props) => {
    const {
        show,
        onHide,
        callback,
        localized,
        itemNumber,
        serialNumber,
        detailCommentUpdated,
        detailComment,
        showFooter,
        IsDetailOnly,
    } = props;

    return (
        <div>
            <MUIModal
                open={show}
                onClose={onHide}
                onSubmit={callback}
                closeLabel={localized.Cancel || 'Cancel'}
                title={IsDetailOnly ? localized.DetailedComments : localized.AddDetailedComments}
                maxWidth="sm"
                showDefaultButtons={false}
                cancelLabel={null}
                submitLabel={null}
            >
                <Container>
                    <Row className="gy-2 gx-3 align-items-center" style={{ paddingBottom: '1rem' }}>
                        <Col xs="auto" className="d-flex align-items-center gap-2 text-nowrap">
                            <div className="heading4">{localized.ItemNumber}:</div>
                            <div>{itemNumber}</div>
                        </Col>

                        <Col xs="auto" className="d-flex align-items-center gap-2 text-nowrap">
                            <div className="heading4">{localized.SerialNumber}:</div>
                            <div>{serialNumber}</div>
                        </Col>
                    </Row>
                    <Row style={{ paddingBottom: '2rem' }}>
                        <Col xs={12} md={11}>
                            <Comments
                                commentsUpdated={detailCommentUpdated}
                                comments={detailComment || ''}
                                editable={IsDetailOnly}
                            />
                        </Col>
                    </Row>
                </Container>
            </MUIModal>
        </div>
    );
};

export default CommentDetailsModal;